export const selectClientDetail = (state: IGlobalState): IClientDetail =>
  state.clientOpt.detail
